import styled from "styled-components";

export const ModalWrapper = styled.div`
  &.modal {
  }

  .modal-dialog {
  }

  .modal-content {
  }

  .modal-footer {
    button {
      font-size: 18px;
      font-family: unset;
      font-weight: 500;
      padding: 10px;
    }
  }
`;
